export default __webpack_public_path__ + "static/media/closet3-1440w.8f1ac5db.avif";